import React from "react";
import { PageLoader } from "@components";
import { useAppSelector } from "@hooks";
import { AITools, Certifications, CertificationsNew, CustomSections, Education, EducationNew, GeneralInfo, Language, OverviewComponent, PersonalStrengths, ProfessionalExperience, Trainings, } from "./sections";
export function CV({ isLoading, onSectionAdd }) {
    const { featureFlags } = useAppSelector((state) => state.ui);
    return isLoading ? (React.createElement(PageLoader, null)) : (React.createElement(React.Fragment, null,
        React.createElement(GeneralInfo, null),
        React.createElement(OverviewComponent, null),
        React.createElement(AITools, null),
        React.createElement(ProfessionalExperience, null),
        React.createElement(EducationNew, null),
        !(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.hideEducationLegacy) && React.createElement(Education, null),
        React.createElement(Language, null),
        React.createElement(CertificationsNew, null),
        !(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.hideCertificationsLegacy) && React.createElement(Certifications, null),
        React.createElement(Trainings, null),
        React.createElement(PersonalStrengths, null),
        React.createElement(CustomSections, { onSectionAdd: onSectionAdd })));
}
